<template>
  <v-container
    id="usageNationalData"
    fluid
    tag="section"
    class="pt-0 pb-0"
  >
    <v-row
      class="pt-0 pb-0"
    >
      <v-col
        cols="12"
        sm="6"
        lg="8"
        class="pt-0"
      >
          <usage12-months-line-chart
            v-if="dataCategory == 'USAGE'"
            :data-year-month="dataYearMonth"
          />
          <usage12-months-excess-line-chart
            v-if="dataCategory == 'EXCESS'"
            :data-year-month="dataYearMonth"
          />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="4"
        class="pt-0"
      >
          <usage-top-ten-pie-chart :data-year-month="dataYearMonth" />
      </v-col>
    </v-row>
    <v-row class="pt-0 pb-0 mt-5">
      <v-col
        cols="12"
        sm="12"
        lg="12"
        class="pt-0 mt-0"
      >
        <v-tabs-items
         v-model="tabs"
         style="background-color:#F5F5F5"
         >
          <v-tab-item>
            <usage-data-table
              category="DOMESTIC DATA"
              data-type="CALL"
              :data-year-month="dataYearMonth"
            />
          </v-tab-item>
          <v-tab-item>
            <usage-data-table
              data-category="DOMESTIC DATA"
              data-type="DURATION"
              :data-year-month="dataYearMonth"
            />
          </v-tab-item>
          <v-tab-item>
            <usage-data-table
              data-category="DOMESTIC DATA"
              data-type="USAGE"
              :data-year-month="dataYearMonth"
            />
          </v-tab-item>
          <v-tab-item>
            <usage-data-table
              data-category="DOMESTIC DATA"
              data-type="EXCESS"
              :data-year-month="dataYearMonth"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Usage12MonthsLineChart from '@/views/blitz/components/apex/UsageData12MonthsLineChart'
  import Usage12MonthsExcessLineChart from '@/views/blitz/components/apex/UsageData12MonthsExcessLineChart'
  import UsageTopTenPieChart from '@/views/blitz/components/apex/UsageDataTopTenPieChart'
  import UsageDataTable from '@/views/blitz/components/UsageDataTable'
  import store from '@/store'

  export default {
    name: 'UsageNationalData',
    components: {
      Usage12MonthsExcessLineChart,
      Usage12MonthsLineChart,
      UsageTopTenPieChart,
      UsageDataTable,
    },
    props: {
      dataType: {
        type: String,
        default: 'USAGE',
      },
      dataYearMonth: {
        type: Number,
      },
    },
    computed: {
      // Following will only add getters..
      // How to add setter ???

      ...mapGetters('app', {
        customerInfo: 'customerInfo',
        snCount: 'snCount', //, ...
      }),
      filterDataYearMonth () {
        return this.dataYearMonth
      },
    },
    watch: {
      dataType: {
        handler () {
          console.log('watching dataType property changed to ' + this.dataType)
          this.switchCategory(this.dataType)
          if (this.dataType === 'USAGE') {
            this.tabs = 2
          }
          if (this.dataType === 'EXCESS') {
            this.tabs = 3
          }
        },
      },
      dataYearMonth: {
        handler () {
          console.log('watching dataYearMonth changed to ' + this.dataYearMonth)
        },
      },

    },
    data () {
      return {
        refreshData: true,
        tabs: 2,
        dataCategory: 'USAGE',
      }
    },
    mounted () {
      if (this.dataType === 'USAGE') {
        this.tabs = 2
      }
      if (this.dataType === 'EXCESS') {
        this.tabs = 3
      }
      if (this.refreshData) {
        store.dispatch('usage/refreshDataCategory', this.dataCategory)
        this.refreshData = false
      }
    },
    methods: {
      switchCategory (category) {
        console.log('switching category to ' + category) // category to CALL, DURATION, DATA, EXCESS
        this.dataCategory = category
        store.dispatch('usage/refreshDataCategory', this.dataCategory)
      },
    },
  }

</script>

<style scoped>

</style>
